module.exports = __webpack_public_path__ + "media/images/facebook-0fa8fe1f1ab9a4d65e6779cf05635042.jpg";